import { Form } from '@ant-design/compatible'

import ManageCultureForm from './ManageCultureForm'

export default Form.create({
  name: 'cultureForm',
})(ManageCultureForm)
